import script from "./sf-assistant-checks-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-assistant-checks-modal.vue?vue&type=script&setup=true&lang=ts"

import "./sf-assistant-checks-modal.vue?vue&type=style&index=0&id=905e8da9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-905e8da9"]])

export default __exports__